import React, { Component } from 'react'

export default class Writer extends Component {
  render() {
    const {onInput,answer}  = this.props;
    return (
    <div>
        <div className='m-auto' style={{maxWidth:'400px'}}>
          <textarea  value={answer} className='p-3 w-100' rows="10"  placeholder="Type your answer here" onInput={onInput}>

          </textarea>
          <div className='text-start py-2'>
              Word Count: {(answer||'').split(' ').map(x=>x.trim()).filter(x=>x.length>0).length}
             </div>
        </div>
        
      </div>
    )
  }
}
